module.exports = __webpack_public_path__ + "static/media/more.9c9255b6.svg";